export const pluralise = (word: string, count: number): string => {
  return `${word}${count > 1 || count === 0 ? 's' : ''}`
}

export const blockCapitalsToCapitalisedWord = (word: string): string => [...word].map((item, index) => index === 0 ? item.toUpperCase() : item.toLowerCase()).join('')

export const capitalisedToHyphenatedWord = (word: string): string => word.split(' ').map(item => item.toLowerCase()).join('-')
